// Where editor.js was loaded from; fonts and the HEIC decoder live next to it.
const src = typeof document === 'undefined' ? undefined : (document.currentScript as HTMLScriptElement | null)?.src;
export const SCRIPT_ORIGIN = src ? new URL(src).origin : 'https://cakeitor.dreamcakes.se';
export const ASSET_BASE = src ? src.replace(/\/[^/]*$/, '') : `${SCRIPT_ORIGIN}/embed`;
